/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prices_Label_Bucket_MediumInputs */

const en_prices_label_bucket_medium = /** @type {(inputs: Prices_Label_Bucket_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medium Bucket`)
};

const es_prices_label_bucket_medium = /** @type {(inputs: Prices_Label_Bucket_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cubo mediano`)
};

const de_prices_label_bucket_medium = /** @type {(inputs: Prices_Label_Bucket_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mittlerer Eimer`)
};

const zh_prices_label_bucket_medium = /** @type {(inputs: Prices_Label_Bucket_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中桶`)
};

const ar_prices_label_bucket_medium = /** @type {(inputs: Prices_Label_Bucket_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سلة متوسطة`)
};

const fr_prices_label_bucket_medium = /** @type {(inputs: Prices_Label_Bucket_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seau moyen`)
};

const vi_prices_label_bucket_medium = /** @type {(inputs: Prices_Label_Bucket_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xô vừa`)
};

const sw_prices_label_bucket_medium = /** @type {(inputs: Prices_Label_Bucket_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ndoo ya Kati`)
};

const th_prices_label_bucket_medium = /** @type {(inputs: Prices_Label_Bucket_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ถังกลาง`)
};

const bs_prices_label_bucket_medium = /** @type {(inputs: Prices_Label_Bucket_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Srednja kanta`)
};

const ja_prices_label_bucket_medium = /** @type {(inputs: Prices_Label_Bucket_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ミディアムバケット`)
};

const ko_prices_label_bucket_medium = /** @type {(inputs: Prices_Label_Bucket_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`미디엄 버킷`)
};

const pt_prices_label_bucket_medium = /** @type {(inputs: Prices_Label_Bucket_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balde médio`)
};

const it_prices_label_bucket_medium = /** @type {(inputs: Prices_Label_Bucket_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cestino medio`)
};

const sv_prices_label_bucket_medium = /** @type {(inputs: Prices_Label_Bucket_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mellanstor hink`)
};

const nl_prices_label_bucket_medium = /** @type {(inputs: Prices_Label_Bucket_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Middelgrote emmer`)
};

const da_prices_label_bucket_medium = /** @type {(inputs: Prices_Label_Bucket_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mellem kurv`)
};

const nb_prices_label_bucket_medium = /** @type {(inputs: Prices_Label_Bucket_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Middels kurv`)
};

const fi_prices_label_bucket_medium = /** @type {(inputs: Prices_Label_Bucket_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keskikokoinen ämpäri`)
};

const pl_prices_label_bucket_medium = /** @type {(inputs: Prices_Label_Bucket_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Średni koszyk`)
};

const ru_prices_label_bucket_medium = /** @type {(inputs: Prices_Label_Bucket_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Средняя корзина`)
};

const tr_prices_label_bucket_medium = /** @type {(inputs: Prices_Label_Bucket_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orta Kova`)
};

const hi_prices_label_bucket_medium = /** @type {(inputs: Prices_Label_Bucket_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मध्यम बाल्टी`)
};

const id_prices_label_bucket_medium = /** @type {(inputs: Prices_Label_Bucket_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ember Sedang`)
};

const ms_prices_label_bucket_medium = /** @type {(inputs: Prices_Label_Bucket_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baldi Sederhana`)
};

const cs_prices_label_bucket_medium = /** @type {(inputs: Prices_Label_Bucket_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Střední košík`)
};

const el_prices_label_bucket_medium = /** @type {(inputs: Prices_Label_Bucket_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μεσαίος κουβάς`)
};

const he_prices_label_bucket_medium = /** @type {(inputs: Prices_Label_Bucket_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`דלי בינוני`)
};

const af_prices_label_bucket_medium = /** @type {(inputs: Prices_Label_Bucket_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medium emmer`)
};

const hu_prices_label_bucket_medium = /** @type {(inputs: Prices_Label_Bucket_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Közepes vödör`)
};

/**
* | output |
* | --- |
* | "Medium Bucket" |
*
* @param {Prices_Label_Bucket_MediumInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const prices_label_bucket_medium = /** @type {((inputs?: Prices_Label_Bucket_MediumInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prices_Label_Bucket_MediumInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prices_label_bucket_medium(inputs)
	if (locale === "de") return de_prices_label_bucket_medium(inputs)
	if (locale === "zh") return zh_prices_label_bucket_medium(inputs)
	if (locale === "ar") return ar_prices_label_bucket_medium(inputs)
	if (locale === "fr") return fr_prices_label_bucket_medium(inputs)
	if (locale === "vi") return vi_prices_label_bucket_medium(inputs)
	if (locale === "sw") return sw_prices_label_bucket_medium(inputs)
	if (locale === "th") return th_prices_label_bucket_medium(inputs)
	if (locale === "bs") return bs_prices_label_bucket_medium(inputs)
	if (locale === "ja") return ja_prices_label_bucket_medium(inputs)
	if (locale === "ko") return ko_prices_label_bucket_medium(inputs)
	if (locale === "pt") return pt_prices_label_bucket_medium(inputs)
	if (locale === "it") return it_prices_label_bucket_medium(inputs)
	if (locale === "sv") return sv_prices_label_bucket_medium(inputs)
	if (locale === "nl") return nl_prices_label_bucket_medium(inputs)
	if (locale === "da") return da_prices_label_bucket_medium(inputs)
	if (locale === "nb") return nb_prices_label_bucket_medium(inputs)
	if (locale === "fi") return fi_prices_label_bucket_medium(inputs)
	if (locale === "pl") return pl_prices_label_bucket_medium(inputs)
	if (locale === "ru") return ru_prices_label_bucket_medium(inputs)
	if (locale === "tr") return tr_prices_label_bucket_medium(inputs)
	if (locale === "hi") return hi_prices_label_bucket_medium(inputs)
	if (locale === "id") return id_prices_label_bucket_medium(inputs)
	if (locale === "ms") return ms_prices_label_bucket_medium(inputs)
	if (locale === "cs") return cs_prices_label_bucket_medium(inputs)
	if (locale === "el") return el_prices_label_bucket_medium(inputs)
	if (locale === "he") return he_prices_label_bucket_medium(inputs)
	if (locale === "af") return af_prices_label_bucket_medium(inputs)
	if (locale === "hu") return hu_prices_label_bucket_medium(inputs)
	return en_prices_label_bucket_medium(inputs)
});